module.exports = __webpack_public_path__ + "static/media/appstore.1dd70e6f.png";